import { render } from "./VehicleTable.vue?vue&type=template&id=93e150b6&scoped=true"
import script from "./VehicleTable.vue?vue&type=script&lang=js"
export * from "./VehicleTable.vue?vue&type=script&lang=js"

import "./VehicleTable.vue?vue&type=style&index=0&id=93e150b6&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e150b6"]])

export default __exports__